import "@babel/polyfill";
import "react-app-polyfill/ie11";
//import './create-nonce';
import {
	isFirefox,
	isEdge,
	isChrome,
	isSafari,
	isMobile
	
} from "react-device-detect";
import { runWithAdal } from "react-adal";
import { authContext } from "./configurations/adalConfig";
// const getIsTenantLogin = () => {
// 	return localStorage.getItem("DCLT") == "" ||
// 		localStorage.getItem("DCLT") == null ||
// 		localStorage.getItem("DCLT") == undefined
// 		? true
// 		: false;
// };

/** Authentication */
const getIsAuthenticated = () => {
	if (
		localStorage.getItem("adal.idtoken") == "" ||
		localStorage.getItem("adal.idtoken") == null ||
		localStorage.getItem("adal.idtoken") == undefined ||
		localStorage.getItem("adal.idtoken") == "undefined"
	) {
		localStorage.removeItem("adal.idtoken");
		localStorage.removeItem("userConfiguration");
		return false;
	} else {
		return true;
	}
};

let DO_NOT_LOGIN = true;
const pathName = (window.location.pathname || "").toLocaleLowerCase();
getIsAuthenticated();
if (pathName == "/dc-user" && getIsAuthenticated() == true) {
	window.location = "/";
} else if (pathName == "/dc-user") {
	DO_NOT_LOGIN = false;
}
if (pathName == "/user" && getIsAuthenticated() == true) {
	window.location = "/";
} else if (pathName == "/user") {
	DO_NOT_LOGIN = true;
}

const isSupportToBrowser =
	(!isMobile && (isChrome || isEdge || isFirefox || isSafari)) || false;
const isSupportMobileBrowser = (isMobile && (isChrome || isSafari)) || false;
const isAbrfRoute = pathName.includes("abrf");

if (!isSupportToBrowser && !isSupportMobileBrowser)
	require("./views/browserNotSupport/browserNotSupport.js");
else if (isAbrfRoute) require("./views/common-page/index");
else
	runWithAdal(
		authContext,
		() => {
			require("./indexapp.js");
		},
		DO_NOT_LOGIN
	);
